export default "__VITE_ASSET__Dw5E27bv__"